import React, { useState, useEffect, useCallback } from 'react';
import './VideoSection.css';

const VIDEO_SRC = `${process.env.PUBLIC_URL}/assets/home_page/v3/videos/compliance.mp4`;

function VideoSection() {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const openLightbox = () => setLightboxOpen(true);
  const closeLightbox = useCallback(() => setLightboxOpen(false), []);

  useEffect(() => {
    if (!lightboxOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') closeLightbox(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [lightboxOpen, closeLightbox]);

  return (
    <section className="pm-web-sec pm-web-video">
      <div className="pm-web-wrap">
        <div className="pm-web-head pm-reveal" style={{ textAlign: 'center' }}>
          <span className="pm-web-eyebrow">See it in action</span>
          <h2 className="pm-web-h2">See the AI system review a daily submission.</h2>
          <p className="pm-web-lede" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            A look under the hood: the AI kicks off its review as inspection data is submitted, checking the day's work against your project requirements.
          </p>
        </div>

        <div
          className="pm-web-video-frame pm-reveal"
          style={{ '--reveal-delay': '120ms' }}
          onClick={openLightbox}
          role="button"
          tabIndex={0}
          aria-label="Play demonstration video"
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') openLightbox(); }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/prime/platform-overview.png`}
            alt="AI Oversight demonstration poster"
          />
          <div className="pm-web-video-play">
            <span className="pm-web-video-play__btn" aria-hidden="true">
              <i className="bx bx-play"></i>
            </span>
            <span className="pm-web-video-play__label">Play demonstration</span>
          </div>
        </div>

        <div className="pm-web-video-points pm-reveal" style={{ '--reveal-delay': '200ms' }}>
          <span><i className="bx bx-check"></i> Real inspection data, reviewed live</span>
          <span><i className="bx bx-check"></i> Issues flagged and routed back to the field</span>
          <span><i className="bx bx-check"></i> Validated work flows straight through</span>
        </div>
      </div>

      {lightboxOpen && (
        <div
          className="pm-lightbox"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label="Demonstration video"
        >
          <button className="pm-lightbox-close" onClick={closeLightbox} aria-label="Close video">
            <i className="bx bx-x" />
          </button>
          <div className="pm-lightbox-content" onClick={e => e.stopPropagation()}>
            <video
              src={VIDEO_SRC}
              controls
              autoPlay
              playsInline
              className="pm-lightbox-video"
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default VideoSection;
